import { DateTime } from 'luxon';

// function isStrEmpty(str: string): boolean {
//   return !str.trim();
// }

const store = {
  getters: { timeZone: 'America/New_York' }
};
const TIME_ZONE = store.getters.timeZone || 'America/New_York';
const DATE_SHORT = 'MM/dd/yyyy';
/**
* 分钟转小时 24小时制 格式：13:25
*/
export function minuteTo24Hour(minutes: number): string {
  if (String(minutes) === 'null' || String(minutes) === 'undefined') {
    return '';
  }
  minutes = Number(minutes);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const flags = {
    a: h % 12 || 12, // 小时，12小时制，1
    aa: pad(h % 12 || 12), // 小时，12小时制，补0，01
    A: h, // 小时，24小时制，1
    AA: pad(h), // 小时，24小时制，补0，01
    b: m, // 分钟，1
    bb: pad(m), // 分钟，补0，01
    t: h < 12 ? 'am' : 'pm',
    T: h < 12 ? 'AM' : 'PM'
  };
  return 'AA:bb T'.replace(/([aAbBTt])\1?|"[^"]*"|'[^']*'/g, function ($0) {
    // @ts-ignore
    return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
  });
  /**
  * 日期补0
  */
  function pad(val: number, len = 2): string {
    let sVal = String(val);
    while (sVal.length < len) {
      sVal = '0' + sVal;
    }
    return sVal;
  }
}
/**
* 时间戳转化为字符串
* @param {*} time  DateTime.DATETIME_SHORT  10/14/1983, 1:30
*/
export function parseTimestamp(
  time: number | null | undefined,
  cFormat?: string,
  timeZone?: string
): string {
  if (time === null || time === undefined) {
    return '---';
  }
  if (!timeZone) {
    timeZone = store.getters.timeZone || 'America/New_York';
  }
  time = Number(time);
  if (!cFormat) {
    cFormat = 'MM/dd/yyyy T';
  }
  return DateTime.fromMillis(time)
    .setLocale('en')
    .setZone(timeZone)
    .toFormat(cFormat);
}
/**
* 格式化 Unix时间戳 到指定格式
* @param {*} time  Unix 时间戳
* @param {*} cFormat  默认 MM/dd/yyyy t
* @param {*} zoneId  租户时间 MM/dd/yyyy t
*/
export function formatUnixTimeStampToZoneStr(
  time: number | null | undefined,
  cFormat?: string
): string {
  if (time === null || time === undefined) {
    return '---';
  }
  time = Number(time) * 1000;
  if (!cFormat) {
    cFormat = 'MM/dd/yyyy t';
  }
  return DateTime.fromMillis(time)
    .setLocale('en')
    .setZone(TIME_ZONE)
    .toFormat(cFormat);
}
/**
* Unix时间戳转转为 Est 格式化
* @param {*} time  Unix 时间戳
* @param {*} cFormat  默认 MM/dd/yyyy
*/
export function formatUnixTimeStampToUtcStr(
  time: number | null | undefined,
  cFormat?: string
): string {
  if (time === null || time === undefined) {
    return '---';
  }
  time = Number(time) * 1000;
  if (!cFormat) {
    cFormat = 'MM/dd/yyyy';
  }
  return DateTime.fromMillis(time, { zone: 'utc' })
    .setLocale('en')
    .toFormat(cFormat);
}
/**
* DATE_SHORT  MM/dd/yyyy
* DATE_ISO yyyy-MM-dd
*/
export function parseIsoToShort(date: string): string {
  return DateTime.fromISO(date).toFormat(DATE_SHORT);
}
export function nextIsoDate(date: string): string | null {
  return DateTime.fromISO(date).plus({ days: 1 }).toISODate();
}
export function parseJsDateToIsoDate(date: Date): string | null {
  return DateTime.fromJSDate(date).toISODate();
}
export function todayIsoDate(): string | null {
  return DateTime.local().setZone(TIME_ZONE).toISODate();
}
export function todayIsoDateFromLocal(): string | null {
  return DateTime.local().toISODate();
}
export function tomorrowIsoDate(): string | null {
  return DateTime.local().setZone(TIME_ZONE).plus({ days: 1 }).toISODate();
}
export function tomorrowShortDate(): string {
  return DateTime.local().setZone(TIME_ZONE).plus({ days: 1 }).toFormat(DATE_SHORT);
}
/**
* 月份中英文
*/
export function getMonthStr(currentMonth: number): string | null {
  let month: string | null = null;
  switch (currentMonth) {
    case 1:
      month = 'January';
      break;
    case 2:
      month = 'February';
      break;
    case 3:
      month = 'March';
      break;
    case 4:
      month = 'April';
      break;
    case 5:
      month = 'May';
      break;
    case 6:
      month = 'June';
      break;
    case 7:
      month = 'July';
      break;
    case 8:
      month = 'August';
      break;
    case 9:
      month = 'September';
      break;
    case 10:
      month = 'October';
      break;
    case 11:
      month = 'November';
      break;
    case 12:
      month = 'December';
      break;
  }
  return month;
}
export function changeDateStrFormat(
  dateStr: string,
  nowFormat: string,
  toFormat: string
): string {
  return DateTime.fromFormat(dateStr, nowFormat).toFormat(toFormat);
}
export function today(format?: string): string {
  if (!format) {
    format = DATE_SHORT;
  }
  return DateTime.local().toFormat(format);
}
export function todayFormat(format?: string): string {
  if (!format) {
    format = DATE_SHORT;
  }
  return DateTime.local().toFormat(format);
}

export function dateIsToday(time?:any, timeZoneId?:any){
  if (!timeZoneId) {
    timeZoneId = 'America/New_York';
  }
  return time >= DateTime.local().setZone(timeZoneId).startOf('day') && time <= DateTime.local().setZone(timeZoneId).endOf('day');
}

/**
 * 时间戳 转换为特定时区的时间字符串
 */
export function timeToStrByTimeZone (time: string | number, timeZoneId: string |null = 'America/New_York', format: string) {
  if (!timeZoneId) {
    timeZoneId = 'America/New_York';
  }
  if (!format) {
    format = 'MM/dd/yyyy';
  }
  return DateTime.fromMillis(Number(time), {zone: timeZoneId}).setLocale("en").toFormat(format);
}

/**
 * 根据时间加天数
 */
export function plusDays (time:number, days:number) {
  if (!time) {
    time = new Date().getTime();
  }
  if (!days) {
    days = 0;
  }
  time = time + days * 24 * 60 * 60 * 1000;
  return new Date(time).getTime();
}

/**
 * 分钟转换为24小时制的时间格式
 */
export function minuteToStr (time: number) {
  if (Number(time) >= 1440) {
    time = Number(time) - 1440;
  }
  return minuteTo24Hour(Number(time));
}

/**
 * 分钟转换为12小时制的时间格式
 */
export function minuteTo12Str(time: number): string {
  if (Number(time) >= 1440) {
    time = Number(time) - 1440;
  }
  return minuteTo12Hour(Number(time));
}

export function minuteTo12Hour(minutes: number): string {
  if (String(minutes) === 'null' || String(minutes) === 'undefined') {
    return '';
  }
  minutes = Number(minutes);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  const period = h < 12 ? 'AM' : 'PM';
  const convertedHour = h % 12 || 12;

  function pad(val: number, len = 2): string {
    let sVal = String(val);
    while (sVal.length < len) {
      sVal = '0' + sVal;
    }
    return sVal;
  }

  return `${pad(convertedHour)}:${pad(m)} ${period}`;
}

export function getWeekDayName (index: any) {
  let ret = 'Monday';
  switch (index) {
    case 1:
      ret = 'Monday';
      break;
    case 2:
      ret = 'Tuesday';
      break;
    case 3:
      ret = 'Wednesday';
      break;
    case 4:
      ret = 'Thursday';
      break;
    case 5:
      ret = 'Friday';
      break;
    case 6:
      ret = 'Saturday';
      break;
    case 7:
      ret = 'Sunday';
      break;
    default:
      break;
  }
  return ret;
}

/**
 * 计算积分过期示例日期
 * @param {number} months 过期月数
 * @returns {string} 格式化的日期字符串
 */
export function getPointsExpirationDateExample(months: number): string {
  if (!months || typeof months !== 'number') {
    return '';
  }

  try {
    // 固定起始日期为2025年6月10日
    const startDate = DateTime.local(2025, 6, 10); // luxon 月份是1-12
    
    // 计算过期日期（目标月份的最后一天）
    const expirationDate = startDate.plus({ months }).endOf('month');

    // 格式化日期
    const startDateStr = startDate.toFormat('MMMM d, yyyy');
    const expDateStr = expirationDate.toFormat('MMMM d, yyyy');

    return `Earned on ${startDateStr} - Expires on ${expDateStr}`;
  } catch (error) {
    console.error('Error calculating expiration date:', error);
    return '';
  }
}
